import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import PasswordField from "./PasswordField";
import {passwordValidationRules, handlePasswordValidation} from "../utils/helpers";
import PasswordChecklist from "./PasswordChecklist";

interface Props {
	onUpdateSubmit?: (password: string, oldPassword: string) => void;
	onResetSubmit?: (password: string) => void;
}

const Messages = styled.div`
	margin: auto;
	margin-bottom: 2rem;
	color: var(--moi-color-red-dark);
	max-width: 20rem;
	text-align: left;
`;

const InputContainer = styled.div`
	margin: auto;
	max-width: 20rem;
	text-align: left;
	
	input {
		margin-bottom: 8px;
	}
`;

const ButtonContainer = styled.div`
	margin: auto;
	max-width: 20rem;
	text-align: center;
`;

const SendButton = styled.button`
	margin: auto;
`;

export const PasswordForm: React.FC<Props> = (props: Props) => {
	const [newPass, setNewPass] = useState('');
	const [errors, setErrors] = useState<string[]>([]);
	const [confirmationPass, setConfirmationPass] = useState('');
	const [identical, setIdentical] = useState(false); // TODO could use useValidation hook
	const [oldPassword, setOldPassword] = useState('');

	useEffect(() => {
		if (newPass !== '' && confirmationPass !== '') {
			setTimeout(() => setIdentical(newPass === confirmationPass), 300);
		}
	}, [newPass, confirmationPass]); // eslint-disable-line

	useEffect(() => {
		setErrors(handlePasswordValidation(newPass));
	}, [newPass]);

	// This form is used for password update and password reset. Old password is required for password update
	const oldPasswordRequired = props.onUpdateSubmit !== undefined;

	return (
		<React.Fragment>
			<InputContainer>
				{oldPasswordRequired && (
					<React.Fragment>
						<PasswordField
							label={"Kirjoita nykyinen salasanasi"}
							id={"currentPassWordField"}
							onChange={(e: React.ChangeEvent<HTMLInputElement>) => setOldPassword(e.target.value)}
							value={oldPassword}
							aria-required={true}
							aria-invalid={oldPassword.length > 0}
						/>
					</React.Fragment>
				)}
				<PasswordField
					label={"Kirjoita uusi salasana"}
					id={"newPassWordField1"}
					onChange={(e: React.ChangeEvent<HTMLInputElement>) => setNewPass(e.target.value)}
					value={newPass}
					aria-invalid={errors.length > 0}
					aria-describedby={"newPasswordInstruction"}
					aria-required={true}
				/>
				<PasswordChecklist
					id={"newPasswordInstruction"}
					value={newPass}
					errors={errors}
					rules={passwordValidationRules}
				/>
				<PasswordField
					label={"Kirjoita salasana uudestaan"}
					id={"newPassWordField2"}
					onChange={(e: React.ChangeEvent<HTMLInputElement>) => setConfirmationPass(e.target.value)}
					value={confirmationPass}
					aria-invalid={!(identical && !errors.length && (!oldPasswordRequired || oldPassword !== ''))}
					aria-describedby={"confirmationMessage"}
					aria-required={true}
				/>
			</InputContainer>
			<Messages id={"confirmationMessage"} aria-live={"polite"}>
				{(newPass !== '' && confirmationPass !== '') && (
					<React.Fragment>
						{!identical ?
							<span className={"notIdentical"}>Salasanat eivät täsmää.</span>
						:
							<span className={"identical sr-only"}>Salasanat täsmäävät.</span>
						}
					</React.Fragment>
				)}
			</Messages>
			<ButtonContainer>
				<SendButton
					className="button"
					disabled={!(identical && !errors.length && (!oldPasswordRequired || oldPassword !== ''))}
					onClick={() => (oldPasswordRequired ? props.onUpdateSubmit!(newPass, oldPassword) : props.onResetSubmit!(newPass))}
				>
					Lähetä
				</SendButton>
			</ButtonContainer>
		</React.Fragment>
	);
};
